import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as ChatTag } from "../../../../../assets/images/ChatImages/chattag.svg";

const sectionCardSx = {
  width: "100%",
  maxWidth: 632,
  minHeight: 80,
  borderRadius: "8px",
  border: "1px solid #E5E9EC",
  background: "#FFF",
  p: 3,
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 1,
};

export default function CustomerDetailTags({ tags }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 20,
          fontWeight: 500,
          lineHeight: "34px",
          mb: 1.5,
        }}
      >
        Tags
      </Typography>
      <Box sx={sectionCardSx}>
        {tags.length === 0 ? (
          <Typography
            sx={{
              color: "#93A1B0",
              fontFamily: "Inter",
              fontSize: 14,
              fontWeight: 400,
            }}
          >
            No tags
          </Typography>
        ) : (
        tags.map((tag) => (
          <Box
            key={tag}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.75,
              px: 1.5,
              py: 0.75,
              borderRadius: "20px",
              border: "1px solid #C5CED6",
              background: "#F9FAFA",
              boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
            }}
          >
            <ChatTag style={{ width: 16, height: 16, flexShrink: 0 }} />
            <Typography
              sx={{
                color: "#405261",
                fontFamily: "Inter",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "18px",
              }}
            >
              {tag}
            </Typography>
          </Box>
        ))
        )}
      </Box>
    </Box>
  );
}
